import WithdrawalsTable from "./WithdrawalsTable";

const WithdrawalsComponent = ({ campaignId }: { campaignId: string }) => {

    return <div className="mt-4 rounded-xl border border-stroke-soft-200 pr-6">
        <div className="flex items-center justify-between">
            <div className="flex p-4">
                <img
                    src="/assets/icons/activity_log.svg"
                    alt=""
                    className="hidden lg:flex"
                />
                <div className="flex flex-col pl-2">
                    <p className="text-body-lg font-[500] text-strong-950 lg:text-body-sm">
                        Withdrawals
                    </p>
                    <p className="text-body-md text-sub-600 lg:text-body-sm">
                        View recent withdrawals out of your campaign.
                    </p>
                </div>
            </div>
            <button className="text-body-md font-[500] text-neutral-900 lg:text-body-sm lg:text-warning-700">
                See all
            </button>
        </div>
        <WithdrawalsTable campaignId={campaignId} />
    </div>;
};

export default WithdrawalsComponent;